import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Row from './row';
import { isEllipsisActive } from '../../../../utility/helpers';

const useStyles = makeStyles(({ palette: { primary } }) => ({
  root: {
    cursor: 'pointer',
    borderBottom: `1px solid ${primary.bluish7}`,
    width: '100%',
  },
}));

const Body = ({
  translations,
  headers,
  rows = [],
  reviewTypes,
  canManage,
  onViewReviews,
  prepareReviewDetailsUrl,
  onFillReview,
  onSendReminder,
  onRenameReview,
}) => {
  const [cellsWithTooltip, setCellsWithTooltip] = useState([]);
  const cellsTooltipRef = useRef([]);

  const classes = useStyles();

  const getCellRef = (element, position, rowKey, hasTooltip) => {
    if (hasTooltip) {
      cellsTooltipRef.current[position] = {
        ...(cellsTooltipRef.current[position]
          ? {
              ...cellsTooltipRef.current[position],
              [rowKey]: element,
            }
          : { [rowKey]: element }),
      };
    }
  };

  useEffect(() => {
    setCellsWithTooltip(
      cellsTooltipRef.current.map(cell => {
        const cellWithTooltip = {};

        Object.keys(cell).forEach(cellKey => {
          cellWithTooltip[cellKey] = isEllipsisActive(
            cell[cellKey],
            false,
            true
          );
        });

        return cellWithTooltip;
      })
    );
  }, [rows]);

  return (
    <div>
      {rows.map((row, index) => (
        <div
          id={row.id}
          key={`row_${row.id}_${index}`}
          className={classes.root}
        >
          <Row
            key={`row_${row.id}_${index}`}
            translations={translations}
            data={row}
            columns={headers}
            position={index}
            reviewTypes={reviewTypes}
            cellsTooltips={cellsWithTooltip}
            canManage={canManage}
            getCellRef={getCellRef}
            onViewReviews={onViewReviews}
            prepareReviewDetailsUrl={prepareReviewDetailsUrl}
            onFillReview={onFillReview}
            onSendReminder={onSendReminder}
            onRenameReview={onRenameReview}
          />
        </div>
      ))}
    </div>
  );
};

Body.propTypes = {
  translations: PropTypes.object.isRequired,
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      rowKey: PropTypes.string.isRequired,
      align: PropTypes.string,
      isHighlighted: PropTypes.bool,
      minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      rowCellClass: PropTypes.string,
    })
  ).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object),
  reviewTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  canManage: PropTypes.bool.isRequired,
  onViewReviews: PropTypes.func.isRequired,
  prepareReviewDetailsUrl: PropTypes.func.isRequired,
  onFillReview: PropTypes.func.isRequired,
  onSendReminder: PropTypes.func.isRequired,
  onRenameReview: PropTypes.func.isRequired,
};

export default Body;
